module.exports = __webpack_public_path__ + "static/media/mv_default.d08e1e1c.jpg";